import styled from "styled-components";
import { Card } from "react-bootstrap";
import {
  faTrashAlt,
  faCheckCircle,
  faPenToSquare,
  faArrowsRotate,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Overlay from "../../../overlay";
import { SUB_PAGE_STATUS } from "../../../strings";
import SubPageStatusIcon from "./sub-page-status-icon";
import SubPageReviseIcon from "./sub-page-revise-icon";
import { useDialog } from "../../../../hooks/useDialog";
import { useTranslation } from "react-i18next";

const ThumbnailDiv = styled.div`
  width: 100%;
  height: 150px;
  background-color: #d9d9d9;
`;

function ServiceCard({
  isActionDisabled,
  onAfterRetrySubPage,
  onAfterDeleteSubPage,
  handleAfterEditSuccess,
  data = { city: "", keywordName: "", status: "", data: {} }
}) {
  const { city, keywordName, status } = data;
  const { FAILED, SUCCESS, PENDING } = SUB_PAGE_STATUS;
  const isFailed = status === FAILED;
  const isPending = status === PENDING;
  const isSuccessful = status === SUCCESS;
  const { t } = useTranslation();
  const { showConfirmationDialogBox, showEditWebsiteSubPageDialogBox } =
    useDialog();

  const toggleDeleteConfirmationDialog = () => {
    showConfirmationDialogBox({
      dialogType: "danger",
      title: t("localSeo.delDialogHeading"),
      dialogMessage: renderDeleteSubPageDialogMessage(),
      responseAction: deleteSubPageDialogResponseAction
    });
  };
  const renderDeleteSubPageDialogMessage = () =>
    isFailed ? (
      <div>{t("localSeo.renderDelNonGeneratedSubPageDialogMsg")}</div>
    ) : (
      <div>{t("localSeo.renderDelGeneratedSubPageDialogMsg")}</div>
    );
  const toggleEditDialog = () =>
    showEditWebsiteSubPageDialogBox({
      data: { ...data.data, city, keywordName, seoPageId: data._id },
      onAfterEditSuccess: (saveResponse) =>
        handleAfterEditSuccess({
          seo: saveResponse.seo,
          sections: saveResponse.sections
        })
    });
  const deleteSubPageDialogResponseAction = (action) => {
    if (action && onAfterDeleteSubPage) {
      onAfterDeleteSubPage();
    }
  };
  const toggleRetryConfirmationDialog = () => {
    showConfirmationDialogBox({
      dialogType: "primary",
      title: t("localSeo.retryDialogHeading"),
      dialogMessage: renderRetrySubPageDialogMessage(),
      responseAction: retryGenerationDialogResponseAction
    });
  };
  const retryGenerationDialogResponseAction = (action) => {
    if (action && onAfterRetrySubPage) {
      onAfterRetrySubPage();
    }
  };
  const renderRetrySubPageDialogMessage = () => (
    <div>{t("localSeo.retryDialogMsg")}</div>
  );

  return (
    <Card className={`rounded-0 ${isPending ? "pe-none" : ""}`}>
      <Overlay show={isPending} />
      <div className="position-relative">
        <ThumbnailDiv />
        <FontAwesomeIcon
          size="lg"
          icon={faTrashAlt}
          onClick={toggleDeleteConfirmationDialog}
          className={`m-2 position-absolute top-0 end-0 cursor-pointer ${
            isActionDisabled ? "pe-none text-secondary" : ""
          }`}
        />
        {isFailed && (
          <SubPageStatusIcon
            icon={faExclamationCircle}
            tooltip={t("localSeo.failed")}
            iconColor={"text-danger"}
          />
        )}
        {isSuccessful && (
          <SubPageStatusIcon
            icon={faCheckCircle}
            tooltip={t("localSeo.successful")}
            iconColor={"text-success"}
          />
        )}
      </div>
      <Card.Body>
        <Card.Text className="d-flex justify-content-between align-items-center">
          <span className="flex-fill">
            <span className="fw-bold text-capitalize">{keywordName}</span>
            {" - "}
            <span className="text-capitalize">{city}</span>
          </span>
          {isSuccessful && (
            <SubPageReviseIcon
              icon={faPenToSquare}
              tooltip={t("common.edit")}
              isDisabled={isActionDisabled}
              handleClick={toggleEditDialog}
            />
          )}
          {isFailed && (
            <SubPageReviseIcon
              icon={faArrowsRotate}
              tooltip={t("localSeo.retry")}
              isDisabled={isActionDisabled}
              additionalStyles="text-primary"
              handleClick={toggleRetryConfirmationDialog}
            />
          )}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default ServiceCard;
